import React from 'react';
// logic
// components
import useQuoteFormSettings from '../components/quoteForm/useQuoteFormSettings';
import NewQuoteToolbar from '../components/newQuote/newQuoteToolbar';
import QuoteForm from '../components/quoteForm/quoteForm';
import PortalContent from '../components/ui/portal/portalContent';
import BasicLoader from '../components/ui/loaders/basicLoader';
import PremiumSectionContainer from '../components/ticketForm/components/PremiumSectionContainer';
import PremiumSection from '../components/ticketForm/components/PremiumSection';
import { InfoMessage } from '../components/ticketForm/components/InfoMessage';
import useNewQuote from '../components/newQuote/useNewQuote';

const NewQuotePage = ({ ...props }) => {
  const id = props.match.params.id;
  const { isLoadingQuoteFormSettings, quoteFormSettings } = useQuoteFormSettings();

  const {
    onSubmit,
    onCancel,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isLoadingTicketDetail,
    ticketDetail,
    ticketDetailError,
  } = useNewQuote({
    id,
  });

  const quoteFormData = {
    ticketDetail,
    quoteFormSettings,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  };

  const isPageReady = !isLoadingTicketDetail && !isLoadingQuoteFormSettings;
  const is404Error = ticketDetailError?.code === 404;
  const customerName = ticketDetail?.shipper_data?.company_name;

  return (
    <>
      <PortalContent>
        <NewQuoteToolbar id={id} customerName={customerName} ticketDetail={ticketDetail} />
      </PortalContent>
      {!isPageReady ? (
        <BasicLoader />
      ) : ticketDetailError ? (
        <PremiumSectionContainer>
          <PremiumSection>
            <InfoMessage>
              {is404Error ? 'Ticket not found' : 'There was an error loading the ticket'}
            </InfoMessage>
          </PremiumSection>
        </PremiumSectionContainer>
      ) : (
        <>
          <QuoteForm quoteFormData={quoteFormData} />
        </>
      )}
    </>
  );
};

export default NewQuotePage;
